var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquidUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC4655"
    },
    d: "M353.524,446.984c-17.954,0-32.508-14.555-32.508-32.508v-73.143h-16.254v-32.508h-97.524v32.508 h-16.254v73.143c0,17.953-14.554,32.508-32.508,32.508s-32.508-14.555-32.508-32.508v8.127c0,26.931,21.831,48.762,48.762,48.762 s48.762-21.831,48.762-48.762v48.762c0,17.953-14.554,32.508-32.508,32.508h16.254c26.931,0,48.762-21.831,48.762-48.762 c0,26.931,21.831,48.762,48.762,48.762h16.254c-17.954,0-32.508-14.555-32.508-32.508v-48.762c0,26.931,21.831,48.762,48.762,48.762 s48.762-21.831,48.762-48.762v-8.127C386.032,432.43,371.478,446.984,353.524,446.984z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9374B"
    },
    d: "M337.27,479.492c31.365,0,56.889-25.52,56.889-56.889v-24.381c0-8.964,7.294-16.254,16.254-16.254 c4.492,0,8.127-3.639,8.127-8.127s-3.635-8.127-8.127-8.127c-17.929,0-32.508,14.583-32.508,32.508v24.381 c0,22.405-18.23,40.635-40.635,40.635s-40.635-18.23-40.635-40.635v-40.635c0-4.488-3.635-8.127-8.127-8.127 s-8.127,3.639-8.127,8.127v40.635C280.381,453.972,305.905,479.492,337.27,479.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC4655"
    },
    d: "M398.223,154.392C368.777,104.85,301.165,0,256.363,0h-0.397 c-44.802,0-112.414,104.85-141.859,154.392c-8.889,14.954-3.994,32.556,12.036,43.472L256,284.444l130.186-86.58 C402.217,186.948,407.111,169.346,398.223,154.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9374B"
    },
    d: "M255.966,0c-44.802,0-112.414,104.85-141.859,154.392c-8.889,14.954-3.994,32.556,12.036,43.472 L256,284.444V0H255.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6646E"
    },
    d: "M256.003,333.206c3.542,0,7.085-0.755,10.207-2.264c16.197-7.83,39.104-12.853,50.77-15.069 c4.388-0.833,7.461-3.805,7.43-7.269C323.585,215.165,303.836,0,256,0h-0.033c-47.836,0-67.585,215.165-68.409,308.604 c-0.031,3.463,3.042,6.435,7.43,7.269c11.666,2.216,34.572,7.239,50.77,15.069c3.122,1.509,6.664,2.264,10.207,2.264"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M207.238,357.587L207.238,357.587c-8.977,0-16.254-7.277-16.254-16.254l0,0 c0-8.977,7.277-16.254,16.254-16.254l0,0c8.977,0,16.254,7.277,16.254,16.254l0,0C223.492,350.31,216.215,357.587,207.238,357.587z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4B3F4E"
    },
    d: "M304.762,357.587L304.762,357.587c-8.977,0-16.254-7.277-16.254-16.254l0,0 c0-8.977,7.277-16.254,16.254-16.254l0,0c8.977,0,16.254,7.277,16.254,16.254l0,0C321.016,350.31,313.739,357.587,304.762,357.587z "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9374B"
    },
    d: "M174.73,479.492c-31.365,0-56.889-25.52-56.889-56.889v-24.381c0-8.964-7.294-16.254-16.254-16.254 c-4.492,0-8.127-3.639-8.127-8.127s3.635-8.127,8.127-8.127c17.929,0,32.508,14.583,32.508,32.508v24.381 c0,22.405,18.23,40.635,40.635,40.635s40.635-18.23,40.635-40.635v-40.635c0-4.488,3.635-8.127,8.127-8.127s8.127,3.639,8.127,8.127 v40.635C231.619,453.972,206.095,479.492,174.73,479.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC4655"
    },
    d: "M255.621,0.049C208.04,1.1,188.379,215.394,187.558,308.604c-0.031,3.463,3.042,6.435,7.431,7.268 c7.032,1.336,18.155,3.711,29.423,7.086C227.308,225.266,237.088,84.834,255.621,0.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9374B"
    },
    d: "M321.016,495.746h-16.254c-22.405,0-40.635-18.23-40.635-40.635v-56.889 c0-4.488-3.635-8.127-8.127-8.127s-8.127,3.639-8.127,8.127v56.889c0,22.405-18.23,40.635-40.635,40.635h-16.254 c-4.492,0-8.127,3.639-8.127,8.127s3.635,8.127,8.127,8.127h16.254c20.704,0,38.81-11.157,48.762-27.739 C265.952,500.843,284.058,512,304.762,512h16.254c4.492,0,8.127-3.639,8.127-8.127S325.508,495.746,321.016,495.746z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquidUserIcon);
export default __webpack_public_path__ + "static/media/squid-user-icon.2e5e24798902e6426dcea2df9537c507.svg";
export { ForwardRef as ReactComponent };